module.exports = __webpack_public_path__ + "static/img/image_3.054850aa.png";